import { render, staticRenderFns } from "./Navbar.component.vue?vue&type=template&id=38ef97dd&"
import script from "./Navbar.component.vue?vue&type=script&lang=js&"
export * from "./Navbar.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports